export const isAttributeUnavailable = availability =>
  !!availability && ["unavailable", "deprecated"].includes(availability.status);
